import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const getPostComments = async (params) => {
  const res = await axios.apiCadernoVirtual("/socialmedia-service/comments", {
    params,
  });
  const flatCommentsList = res.object;

  const commentsWithChildren = flatCommentsList
    .map((comment) => {
      return {
        ...comment,
        replies: flatCommentsList.filter((_c) => {
          return _c.parentId === comment.id;
        }),
      };
    })
    .filter((comment) => {
      return comment.parentId === 0 && !Boolean(comment.excludedBy);
    });

  return commentsWithChildren;
};

export const usePostComments = ({ config, postId } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["postComments", { postId }],
    queryFn: () =>
      getPostComments({
        postId,
        studentId: _cookies.getItem("auth").user?.alunoid,
      }),
  });
};
